<template>

<Tab :style="cssVars" @dimensions_changed="d => landscape = d.orientation === 'landscape' || d.width >= 800">
    <div class="wrapper grid">
        <section class="content">
            <div class="read-more-intro">
                <h2>Про проєкт</h2>
                <div class="read-more-intro-text">  
                    <p> 
Мета проєкту — зробити зручний інструмент для містян, який дозволить моніторити зміни в публічному просторі. Проєкт буде корисним для контролю над порушеннями благоустрою та їх усуненням. Також з нього можна дізнатися про розміщення тимчасових споруд та зовнішньої реклами — ви можете перевірити наявність дозволу на розміщення рекламного носія або перевірити, чи відповідає розміщена тимчасова споруда виданій технічній документації.
                    </p>

                    <!-- <a href="#tab" class="blyat button">Читати далі</a> -->
                </div>
                <span/>
                <router-link to="/about" class="blyat button">Читати далі</router-link>
            </div>
        </section>
    </div>

    <div class="wraper grid">
        <section class="content text-w">
            <h2>Порушення благоустрою</h2>
            <p>
На цій карті можна знайти інформацію про те, які організації отримали найбільшу кількість приписів про порушення благоустрою, які типи порушень зафіксовані, чи усунуто виявлені проблеми.
            </p>
        </section>

        <section class="informer-stripe full-width grid interactive-bg">
            <div class="content">
                <!-- <div class="informer-box"> -->
                    <h5>Топ організацій, яким видані приписи порушення благоустрою</h5>
                <!-- </div> -->
                <top-chart v-if="top_data" :data='top_data' :params="{total: 'усі ', completed: 'виконані порушення'}"></top-chart>
            </div>
        </section>
        <!-- <section class="content text-w">
            <p>Оберіть часовий проміжок щоб дізнатись кількість порушень за період та відфільтрувати їх на карті:</p>   
        </section> -->
        
        <section v-if="!landscape" class="full-width grid interactive-bg">
            <rotate-your-phone class="content text-w"/>
        </section>
        <template v-else>
        <section class="full-width grid interactive-bg" style="padding-top: 2em;">
            <div class="content">
                <info-spoiler>
                    <template v-slot:caption>
                        <img src="../assets/backhand_finger_down.png" style="width: 2em; vertical-align: middle;" /> <h6> Як користуватись картою? </h6>
                    </template>
                    <div class="fucking-text">

<p>На карті відображені порушення, зафіксовані приписами про порушення благоустрою, виданими Інспекцією благоустрою міста Слов’янськ. Синім позначені порушення, які були ліквідовані, фіолетовим – ті, що лишилися або усунення яких не було зафіксовано інспекцією.</p>
<p>На слайдері над картою можна вибрати період для відображення від січня 2019 року. Кількість порушень та часовий проміжок позначені праворуч від карти. Також праворуч біля карти є фільтр, за допомогою якого можна обрати лише виконані чи невиконані приписи. </p>
<p>Якщо клікнути на точку, можна отримати додаткову інформацію про порушення. </p>
<p>Колір та його інтенсивність відображають кількість порушень за певною адресою, а також їх тип. Що інтенсивніше колір – то більше порушень. Якщо колір ближчий до фіолетового – більше порушень, які не усунули, до синього — порушення вже немає.</p>
<p>Праворуч від карти відображений список щодо кожного окремого порушника, а також перелік всіх недоліків за певною адресою.</p>
<p>Під картою можна переглянути інформацію про окреме порушення (порушника) – клікнувши на код ЄДРПОУ, перейти на відповідну  сторінку в Opendatabot) – тип, статус (чи виконано припис), дату фіксації інспектором і точну адресу. </p>
<p>Типи порушень бувають різними – скажімо, неприбране гілля або сніг, нескошена трава або невивезене сміття. На карті ви зможете знайти більше прикладів.</p>

                    </div>
                </info-spoiler>

                <!-- <div class="alert-box" style="max-width: 45em; background-color: white;">
                    <collapsible v-model="infobox" style="border-top: none;" class="info">
                        <template v-slot:caption><h5 style="margin-bottom: 0">Як користуватись картою?</h5></template>
                        
                    </collapsible> -->

                    <!-- <p> <span class="emoji">&#x1F447;</span> Клікніть точку на карті щоб побачити інформацію про порушення </p> -->
                <!-- </div> -->
            </div>            
        </section>
        
        <time-brush class="full-width interactive-bg" 
            v-if="prypysy_original" 
            :points='prypysy_original' 
            @time_extent_changed="change_time_extent" 
        />

        <section class="full-width map-and-filters">
            <div class="map-container">
                <div class="map-loading" v-if="!map_data"> <p>Завантаження ...</p> </div>
                
                <points-map v-else 
                    :points='map_data' 
                    @point-selected="change_point_selected" 
                    :selected_point="selected_point"
                    ref="prypysymapref"
                    :points_style="points_style"
                    :address_search_index="address_search_index"
                />

                <!-- <known-height-block class="main-text" @height_changed="val => buffer_height = val">  -->
                <!-- </known-height-block> -->
            </div>
            
            <div class="filters-container interactive-bg">
                <p class="small-margin-bottom">
                    Приписи про порушення благоустрою 
                    <!-- за період {{time_format(time_extent[0])}} -- {{time_extent[1]}}: -->
                </p>
                <p class="tiny-text" v-if="time_extent">з {{time_format(time_extent[0])}} по {{time_format(time_extent[1])}}</p>
                <div class="buttons" v-if="filtered_stats">
                    <div> <checkbox v-model="show_completed"/> <div class="check-legend" style="background-color: var(--col-win);"></div> <span class="tiny-text"> Виконані <span class="count">({{ filtered_stats.completed.get(true) }})</span></span></div>
                    <div> <checkbox v-model="show_uncompleted"/> <div class="check-legend" style="background-color: var(--col-fail);"></div> <span class="tiny-text"> Не виконані <span class="count">({{ filtered_stats.completed.get(false) }})</span></span></div>
                </div>
                <section class="collapsible-buttons" v-if="selected_point">
                    <collapsible v-model="collapsible_entity">
                        <template v-slot:caption>
                            Всі порушення організації <b>({{violations_by_entity.length}})</b>
                        </template>

                        <li :class="`tiny-text collapsible-item ${item.properties.completed ? 'completed' : 'uncompleted'} ${item.properties.idx === selected_point.properties.idx ? 'selected': ''}`" 
                            v-for="(item, index) in violations_by_entity" 
                            :key="index"
                            @click="$refs.prypysymapref.select_point(item)"
                        >
                            <span :class="`circle ${item.properties.completed ? 'completed' : 'uncompleted'}`" />
                            <span class="time"> {{time_format(item.properties.date)}} </span>   
                            <span class="value"> {{ item.properties.violationType }} </span>
                        </li>
                    </collapsible>
                    
                    <collapsible v-model="collapsible_address" style="border-bottom: 1px solid black;">
                        <template v-slot:caption>
                            Всі порушення за адресою <b>({{violations_by_address.length}})</b>
                        </template>
                        
                        <li :class="`tiny-text collapsible-item ${item.properties.completed ? 'completed' : 'uncompleted'}`" 
                            v-for="(item, index) in violations_by_address" 
                            :key="index"
                            @click="$refs.prypysymapref.select_point(item)"
                        >
                            <span :class="`circle ${item.properties.completed ? 'completed' : 'uncompleted'}`" />
                            <span class="time"> {{time_format(item.properties.date)}} </span>   
                            <span class="value"> {{ item.properties.violationType }} </span>
                        </li>
                    </collapsible>
                </section>
                <!-- <div v-else class="text-center"> -->
                
            <!-- </div> -->
            </div>
        </section>

        <section class="full-width grid infobox-container interactive-bg">
            <div class="content">
                <info-box v-if="selected_point" :d="selected_point"></info-box>
                <div v-else >
                    <div class="alert-box">
                        <p style="text-align: center"> <img src="../assets/finger_up.png" style="width: 2em; vertical-align: middle;" />  Клікніть точку на карті щоб побачити інформацію про порушення </p>
                    </div>
                </div>
            </div>
        </section>

        </template>


        <!-- <section v-if="fines" class="informer-stripe full-width grid" style="background-color: #E7EEF3;">
        </section> -->

        <section class="content text-w after-text">

<p>Інспекція міської ради з благоустрою Слов’янська регулярно проводить перевірки з питань дотримання законодавства у сфері благоустрою. У разі виявлення порушень спеціалісти Інспекції складають відповідний припис –це інструмент контролю. Власник або користувач об'єкта зобов'язаний усунути виявлене, інакше його оштрафують.</p>
<p>Якщо порушення усунене, але на карті це не відображено,  повідомте про це міську інспекцію з благоустрою.</p>
<p>Ви також можете контролювати порушників за допомогою звернень до депутатів міської ради або її виконавчих органів.</p>

            <div class="alert-box">
<p>Помітивши порушення, зверніться до Інспекції міської ради з благоустрою міста Слов’янськ та повідомте про це (площа Соборна, 2, тел. <a href="tel:+3806262-2-43-22">06262 2-43-22</a>, <a href="mailto:inspection@slavrada.gov.ua">inspection@slavrada.gov.ua</a> ).    </p>
            </div>

        </section>
    </div>

</Tab>
</template>

<script>
import Tab from './Tab'
import PointsMap from '../components/PointsMap'
import TopChart from '../components/TopChart'
import Collapsible from '../components/Collapsible'
import InfoBox from '../components/prypysy/InfoBox'
import TimeBrush from '../components/prypysy/TimeBrush'
import KnownHeightBlock from '../components/KnownHeightBlock'
import CheckButton from '../components/CheckButton'
import Checkbox from '../components/other/Checkbox'
import InfoSpoiler from '../components/other/InfoSpoiler'
import RotateYourPhone from '../components/other/rotate/RotateYourPhone'
import { create_index } from '../utils.js'


import check_edrpou from '../check_edrpou'

import * as d3 from 'd3'
import * as d3_array from 'd3-array'
import _ from 'lodash'
import moment from 'moment'

const top_size = 10;

export default {
    name: 'prypysy-tab',
    components: {
        Tab,
        PointsMap,
        TopChart,
        Collapsible,
        InfoBox,
        TimeBrush,
        KnownHeightBlock,
        CheckButton,
        Checkbox,
        InfoSpoiler,
        RotateYourPhone,
    },

    data() {
        return {
            prypysy_original: null,
            top_data: null, 
            selected_point: null,
            time_extent: null,
            show_completed: true,
            show_uncompleted: true,

            selected_entity: null,

            map_data: null,
            filtered_stats: null,

            entity_index: null,
            address_index: null,

            fines: null,
            buffer_height: 0,

            cssVars: {
                '--col-win': "#608FCB",
                '--col-fail': "#AB328A"
            },

            collapsible_entity: true,
            infobox: false,

            landscape: true,
        }
    },

    computed: {
        map_filter() {
            const {
                time_extent,
                show_completed,
                show_uncompleted,
            } = this

            return {
                time_extent,
                show_completed,
                show_uncompleted,
            }
        },

        collapsible_address: {
            get: function() {return !this.collapsible_entity},
            set: function(val) { this.collapsible_entity = !val}
        },

        map_data_debouncer() {
            console.log("compute debouncer func")
            return _.throttle(this.compute_map_data, 300)
        },

        violations_by_entity: function(){
            return this.entity_index
                .get(this.selected_point.properties.entityName)
                // .map(d => d.properties.violationType);
        },

        violations_by_address: function() {
            return this.address_index
                .get(this.selected_point.properties.fullAddress)
                // .map(d => d.properties.violationType);
        },

        address_search_index: function() {
            return Array.from(this.address_index, ([key, value]) => ({ text: key, term: key.toLowerCase(), p: value[0] }))
        }

    },

    created() {
        this.loadData();
    },

    mounted() {
        var self = this;

    },

    methods: {
        async loadData() {
            this.state = {};
            this.filters = {};

            let [prypysy_data, admin_fines, descriptions] = await Promise.all([
                d3.csv('data/prypysy.csv'),
                d3.csv('data/admin_fines.csv'),
                d3.csv('data/violation_descriptions.csv'),
            ]);

            descriptions.forEach(el => {
                el.code = el.code.toUpperCase().trim(); 
                el.description = el.description.trim();
            })
            let descriptions_map = new Map(descriptions.map(r => [r.code, r.description]))

            let violations_without_desc = new Set();

            prypysy_data.forEach((el, idx) => {
                el.date = moment(el.date).toDate()
                el.completed = completed(el.status)
                el.fullAddress = get_full_address(el)
                el.idx = idx
                let long_description = descriptions_map.get(el.violationType.toUpperCase().trim())
                
                if (!long_description) violations_without_desc.add(el.violationType);
                
                el.violationType = long_description ? long_description : el.violationType;

                el.entityId = check_edrpou(el.entityId)

                // ну і хуйню ж я дєлаю
                if (el.legalEntityForm.trim().toUpperCase().startsWith('ФІЗИЧНА ОСОБА')) {
                    el.entityName = el.legalEntityForm;
                    el.person = true;
                }
            });

            // console.warn([...violations_without_desc].join("\n"));

            this.prypysy_original = to_geojson(prypysy_data);

            let grouped = d3_array
                .rollup(
                    this.prypysy_original, 
                    v => ({
                        completed: v.filter(el => el.properties.completed).length, 
                        total: v.length
                    }), 
                    d => d.properties.entityName
                )
            
            this.top_data = Array.from(grouped.entries())
                .map(o => ({key: o[0], params: o[1]}) )
                .sort((o1, o2) => o2.params.total - o1.params.total)
                .slice(0, top_size)

            // Ну і хуйню ж я дєлаю 2
            this.top_data.forEach(o => {
                if (o.key === "Фізична особа підприємець") {
                    o.key = "Фізичні особи підприємці";
                }
            });


            this.entity_index = create_index(
                this.prypysy_original, 
                d => d.properties.entityName,
                d3.descending,
                d => d.properties.date 
            )
            
            this.address_index = create_index(
                this.prypysy_original,
                d => d.properties.fullAddress,
                d3.descending,
                d => d.properties.date
            )
            
            // this.fines = compute_fines_stats(admin_fines)
        },

        compute_map_data() {
            var data = this.prypysy_original;

            data = data.filter(d => +d.properties.Latitude && +d.properties.Longitude)

            if (this.time_extent) {
                data = data.filter(d => d.properties.date >= this.time_extent[0] && d.properties.date <= this.time_extent[1])
            }

            this.filtered_stats = {
                completed: group_count(data, d => d.properties.completed) 
            }
            
            if (!this.show_completed || !this.show_uncompleted) {
                data = data.filter(d => (d.properties.completed && this.show_completed) || (!d.properties.completed && this.show_uncompleted))
            }
            this.map_data = data;
        },

        change_time_extent(ext) {
            this.time_extent = ext;
        },

        change_point_selected(point) {
            this.selected_point = point
        },

        points_style(feature) {
            return {
                radius: 3,
                fillColor: feature.properties.completed ? this.cssVars['--col-win'] : this.cssVars['--col-fail'],
                color: "#000",
                weight: 1,
                opacity: 1,
                fillOpacity: 0.65,
                stroke: 0
            };
        },

        time_format: d3.timeFormat("%Y-%m-%d")
    },

    watch: {
        map_filter: {
            handler: function(val) {
                console.log("map filter changed")
                this.map_data_debouncer();
            }
        }
    }
}        

function group_count(data, field_accessor) {
    return d3_array
        .rollup(data, v => v.length, field_accessor)
}

function to_geojson(data) {
    return data.map(function(d) {
        return {
            type: "Feature",
            properties: d,
            geometry: {
                type: "Point",
                coordinates: [ +d.Longitude, +d.Latitude ]
            }
        };
    });
}



function get_full_address(p) {
    return `${p.addressPostName}, ${p.addressThoroughfare}, ${p.addressLocatorDesignator}`
}

function completed(status) {
    if (!status) return false;

    if (status.toUpperCase().includes("НЕ ВИКОНАНО")) {
        return false;
    }

    if (status.toUpperCase().includes("ВИКОНАНО")) {
        return true;
    }

    return false;
}
</script>

<style scoped lang="scss">

.collapsible-item {
    display: flex;
    margin-bottom: 0.3em;
    
    cursor: pointer;

    .time {
        display: inline-block;
        min-width: 7em;
    }

    &:hover > * {
        border-bottom: 1px solid black;
    }

    .circle {
        display: table;
        width: 0.7em;
        height: 0.7em;
        border-radius: 50%;
        margin-top: 0.35em;
        margin-right: 0.3em;

        &.completed {background-color: var(--col-win)};
        &.uncompleted {background-color: var(--col-fail)};
    }

    &.selected {
        font-weight: 500;
    }

// &.completed .time { 
    //     color: var(--col-win);
    // }

    // &.uncompleted .time {
    //     color: var(--col-fail);
    // }
}

// .checkbox.inactive {
//     background-color: #ccc !important;
// }

.highlight {
    background-color: red; // t1-main
    font-weight: 600;
    padding: .25em .5em;
    border-radius: 0.5em;
}

.infobox-container {
    padding: 2em 0;
}

.topchart-section {
    display: flex;
    gap: 2em;
    justify-content: space-between;
}

/deep/ .topbarchart {
    width: 100%;
    max-width: 44em;
    min-width: 20em;
    font-size: 16px;

    .param.param-total {
        background-color: var(--col-fail);
        z-index: 10;
        color: white;
    }

    .param.param-completed {
        background-color: var(--col-win);
        z-index: 11;
        color: white;
    }

    .param, .caption {
        cursor: initial;
    }

    // .row:hover {
    //     .param {
    //         background-color: white;
    //         border: 1px solid black;
    //         color: black;
    //     }
    //     //.param.param-completed {background-color: $t1_completed_hot;}

    // }
}

.map-and-filters{
    display: grid;
    grid-template-columns: 6fr 3fr;

    .filters-container {
        padding: 1rem;
        // background-color: var(--col-interactive-bg);   

        .buttons {
            margin-bottom: 1.5em;
            display: flex;
            gap: 3em;

            /deep/ .style-win {
                button {
                    background-color: var(--col-win);
                    color: white;

                    &.inactive {
                        background-color: unset;
                        border: 1px solid black;
                        color: black;
                    }
                }
            }

            /deep/ .style-fail {
                button {
                    background-color: var(--col-fail);
                }
            }

            /deep/ button.inactive {
                background-color: unset;
                border: 1px solid black;
                color: black;
            }           
            // justify-content: space-between;
        }
    }
}

.after-text {
    margin: 4em 0;
}

.count {
    display: inline-block;
    min-width: 3.5em;
}

/deep/ .info-spoiler {
    background: white;

    h6 {
        margin-bottom: 0;
    }
}

.read-more-intro {
    margin-top: 3em;
    margin-bottom: 6em;

    display: grid;
    grid-column-gap: 1em;
    grid-template-columns: 2fr 3fr;

    h2 {
        align-self: center;
    }
}

.blyat.button {
    color: white;
    background: black;
    display: inline-block;
    margin-top: 0; 

    &:hover {
        background: var(--diia-gradient);
        // color: black;
        border-color: white;
    }
}


@media screen and (max-width: 600px){
    .read-more-intro {
        display: block;
    }
}

</style>

